<template>
  <div>
    <customFieldsRenderer target="venuesSharedCustomFields" :fields="venuesSharedCustomFields" :item="{ custom_fields: venuesSharedCustomFieldsValues }"
      @operation="updateVenuesSharedCustomFieldsValues" @update="getVenuesSharedCustomFields" @manage="manage" />
    <customFieldsManage v-if="editAction" inline :editAction="editAction" @hide="editAction = null" @update="getVenuesSharedCustomFields" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import api from '@/api'
import customFieldsRenderer from './CustomFieldsRender'
import customFieldsManage from './CustomFields'

export default {
  name: 'VenuesSharedCustomFields',
  components: { customFieldsRenderer, customFieldsManage },
  data() {
    return {
      venuesSharedCustomFieldsValues: [],
      venuesSharedCustomFields: [],
      editAction: null
    }
  },
  computed: {
    ...mapGetters([
      'languages',
      'customFieldsTypeTranslations'
    ]),
    ...mapState(['customFields']),
  },
  methods: {
    manage() {
      this.editAction = { target: 'venuesSharedCustomFields', fields: this.venuesSharedCustomFields, onUpdate: this.getVenuesSharedCustomFields }
    },
    updateVenuesSharedCustomFieldsValues(operation) {
      api.updateVenuesSharedCustomFieldsValues(operation.value.id, [
        {
          from: operation.from,
          value: operation.value.value,
          type: 'value'
        }, {
          value: operation.value.option_id,
          type: 'option_id'
        }
      ])
    },
    getVenuesSharedCustomFields() {
      api.venuesSharedCustomFieldsValues().then(data => {
        this.venuesSharedCustomFieldsValues = data.map(cfv => ({ ...cfv, value_id: cfv.id, id: cfv.option_id }))
        return api.venuesSharedCustomFields()
      })
        .then(data => {
          this.venuesSharedCustomFields = data.map(cf => ({
            ...cf,
            label: cf.title,
            type_definition: cf.type,
            item_type: 'venuesSharedCustomFields',
            inputTypeAttrs: {
              ...this.customFieldsTypeTranslations[cf.type.type],
              label: cf.title,
              customFieldValueWrapper: {
                option_id: cf.id,
                id: this.venuesSharedCustomFieldsValues.find(i => i.option_id === cf.id)?.value_id || 0,
                value: {
                  type: cf.type.type,
                  value: null
                }
              }
            }
          }))
          if (this.editAction) {
            this.manage()
          }
        })
    }
  },
  mounted() {
    this.getVenuesSharedCustomFields()
  }
}
</script>

<style>
</style>